import React, { useContext, useEffect, useState } from 'react';
import { Card, CardBody, CardHeader, Col, Row } from 'reactstrap';
import { List } from './List';
import { AuthContext } from 'contexts/AuthContext';
import { getUsers } from "utils/api";

export const AdminUsers = () => {
    const { handleError } = useContext(AuthContext);

    const [users, setUsers] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const fetchUsers = async () => {
        setIsLoading(true);

        try {
            const res = await getUsers();
            const usrArr = res?.users?.filter((user) => !user.roles?.includes('ROLE_SUPER_ADMIN'));
            setUsers(usrArr);
        } catch (err) {
            handleError(err);
        }

        setIsLoading(false);
    };

    useEffect(() => {
        fetchUsers();
    }, []);

    return (
        <div className="view view--mobile-full">
            <div className="animated fadeIn">
                <Row>
                    <Col xs="12">
                        <Card>
                            <CardHeader>
                                <div className="flex-space-between">
                                    <h1>Users</h1>
                                </div>
                            </CardHeader>
                            <CardBody>
                                <List users={users} isLoading={isLoading} refreshUsers={fetchUsers}/>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
        </div>
    );
};
